export default {
  shape:
    '<path d="M13.6074 1.03577L5.60738 8.67213L1.60742 4.85395" stroke="#22CCD8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
  viewBox: [0, 0, 15, 10],
};
